import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';

class CompanyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }
  
  render() {
    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "email",
        label: "Email",
        options: {
          filter: true
        }
      },
      {
        label: "Name",
        name: "name",
        options: {
          filter: true
        }
      },
      {
        label: "Birthday",
        name: "brithday",
        options: {
          filter: true
        }
      },
      {
        label: "Gender",
        name: "gender",
        options: {
          filter: true
        }
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: true
        }
      },
      {
        label: "Job",
        name: "job",
        options: {
          filter: true
        }
      },
      {
        label: "Company Code",
        name: "company_code",
        options: {
          filter: true
        }
      },
      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = (tableMeta.rowData !== undefined) ? tableMeta.rowData[0]:0
            return (
              <div>
                <Button variant="outlined" color="secondary" onClick={() => this.props.handleDelete(id)}>
                  Delete
                </Button>
                <Button variant="outlined" color="primary" onClick={()=>this.props.restate(tableMeta.rowData)} >
                  Update
                </Button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll"
    };

    return (
      <MUIDataTable
        title={"User"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default CompanyList;
